import { render, staticRenderFns } from "./BuilderProjects.vue?vue&type=template&id=459211fe&"
import script from "./BuilderProjects.vue?vue&type=script&lang=js&"
export * from "./BuilderProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports